import createReactComponent from '../createReactComponent';
export default createReactComponent('stairs-down', 'IconStairsDown', [
  ['path', { d: 'M4 20h4v-4h4v-4h4v-4h4', key: 'svg-0' }],
  ['path', { d: 'M11 4l-7 7v-4m4 4h-4', key: 'svg-1' }],
]);
